import React, { memo } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { PRIMARY_LIGHT, PRIMARY, PRIMARY_DARK, SECONDARY } from 'styles/colors';

/*
  Material needs to be filled with these all array positions
  to prevents warnings and "elevation is not implemented" errors
  https://github.com/mui-org/material-ui/issues/17398
*/
const REMOVE_SHADOWS = new Array(25).fill('none');

export const theme = createMuiTheme({
  palette: {
    primary: {
      light: PRIMARY_LIGHT,
      main: PRIMARY,
      dark: PRIMARY_DARK
    },
    secondary: {
      main: SECONDARY,
    },
    background: {
      default: '#fff'
    }
  },
  shadows: REMOVE_SHADOWS,
  typography: {
    fontFamily: 'Montserrat, sans-serif',
  },
  overrides: {
    MuiButton: {
      contained: {
        color: '#fff',
        borderRadius: 20,
        padding: '12px 20px 10px',
        fontSize: '14px',
        fontWeight: 600,
        '&$disabled': {
          'backgroundColor': '#ccc',
          color: '#fff',
        }
      },
      outlined: {
        borderRadius: 20,
        padding: '12px 20px 10px',
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 600,
      },
      outlinedSizeLarge: {
        padding: '12px 20px 10px',
      },
      root: {
        fontSize: '14px',
        color: '#fff',
        padding: '12px 20px 10px',
        '&.padding': {
          paddingLeft: '13%',
          paddingRight: '13%',
        },
        '&.noHoverBg:hover': {
          background: 'none'
        },
        textTransform: 'none',
        '&$disabled': {
          'backgroundColor': '#ccc',
        }
      },
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: 540,
      },
    },
    MuiFormControl: {
      root: {
        minHeight: '56px'
      }
    },
    MuiIconButton: {
      root: {
        '&.noHoverBg:hover': {
          background: 'none'
        },
      }
    },
    MuiInputLabel: {
      root: {
        fontSize: '14px',
        fontWeight: 500
      }
    },
    MuiInputBase: {
      input: {
        fontSize: '14px',
        fontWeight: 500,
        backgroundColor: '#FFF'
      },
    },
    MuiTabs: {
      root: {
        background: 'linear-gradient(to bottom, transparent 98%, #d8d8d8)'
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        border: '1px solid #d8d8d8',
        borderBottom: '0',
        marginLeft: '5px',
        marginRight: '5px',
        '&.Mui-selected': {
          backgroundColor: '#f8f8f8',
          fontWeight: 600,
          borderTop: `2px solid ${SECONDARY}`,
          transition: 'border .4s ease'
        }
      },
    }
  },
});

const Provider = ({ children }) => (
  <ThemeProvider theme={theme}>
    {children}
  </ThemeProvider>
);

export default memo(Provider);
